import { useObserver } from "mobx-react";
import TabSelector from "./TabSelector";
import Input from "./input";
import Select from "./Select";
import Skills from "./Skills";
import TextArea from "./TextArea";
import Experience from "./experience";
import PercentageInput from "./PercentageInput";
import NumberSelector from "./NumberSelector";
import { useState } from "react";

export default function Test1() {
  const [value, setValue] = useState(10);
  return useObserver(()=> (
    <div>
      test
      <TabSelector />
      <div className="p-10">
      <Input label="test" type="text" placeholder="test" value="hello" action={(e)=>{console.log(e.target.value)}} />
      <Input label="test" type="number" placeholder="test" action={(e)=>{console.log(e.target.value)}} />
      <Select label="test" value="test" action={(e)=>{console.log(e.target.value)}} options={[{label:"test", value:"test"}, {label:"test1", value:"test1"}]} />
      <Skills Skills={["test", "test1", "test2"]} />
      <TextArea label="test" action={(e)=>{console.log(e.target.value)}} />
      <Experience label="test" value="test" action1={(e)=>{console.log(e.target.value)}} action2={(e)=>{console.log(e.target.value)}} />
      <PercentageInput label="test" type="number" placeholder="test" value="test" tooltip="score" action={(e)=>{console.log(e)}} />
      <NumberSelector label="Aptitude" placeholder="test" value={value} action={(e)=>{ setValue(e)}} />
      </div>
    </div>
  ));
}